import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/**
 * `<RecoveryPassphraseEntryStep />` — patient enters recovery
 * passphrase (separate factor per scope memo §5.2).
 *
 * **NO SHT BACKDOOR.** The recovery passphrase NEVER leaves the
 * client. Phase B integration: passphrase + salt → canonical
 * `deriveKeyFromPassphrase` → unwraps server-returned wrapped-PMK
 * client-side. Phase A scaffolding stubs the cryptographic step
 * but preserves the doctrinal posture (passphrase only flows from
 * the input field to the orchestrator's local stack; never to a
 * network surface).
 */
import * as React from 'react';
import { useLocale } from '../../i18n/locale-context.js';
export function RecoveryPassphraseEntryStep(props) {
    const { t } = useLocale();
    const [passphrase, setPassphrase] = React.useState('');
    const handleSubmit = (e) => {
        e.preventDefault();
        if (passphrase.length === 0) {
            return;
        }
        props.onSubmit(passphrase);
        setPassphrase('');
    };
    return (_jsxs("section", { "aria-labelledby": "passphrase-heading", children: [_jsx("h3", { id: "passphrase-heading", children: t('recovery.passphrase.heading') }), _jsx("p", { children: t('recovery.passphrase.body') }), _jsxs("form", { onSubmit: handleSubmit, children: [_jsxs("label", { children: [t('recovery.passphrase.input_label'), _jsx("input", { type: "password", value: passphrase, onChange: (e) => setPassphrase(e.target.value), autoComplete: "off", required: true })] }), _jsxs("div", { role: "group", "aria-label": t('recovery.passphrase.actions_aria_label'), children: [_jsx("button", { type: "submit", disabled: passphrase.length === 0, children: t('recovery.passphrase.submit') }), _jsx("button", { type: "button", onClick: props.onCancel, children: t('recovery.passphrase.cancel') })] })] })] }));
}
//# sourceMappingURL=passphrase-entry-step.js.map